import Vue from "vue";
import Router from "vue-router";
import routes from './router.js'
import store from '@/store'
import { processMenuNavigation, hasCustomReportMenu } from '@/utils/menu'

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};

const router = new Router({
    mode: "history",
    routes
});

router.beforeEach(async (to, form, next) => {
    console.log("🐉🐉🐉 ~ router.beforeEach ~ to:", to)
    const isRedirection = to.path == '/redirection' && to.query.token
    if (isRedirection) {
        window.location = '/bi-web/login/login-from-bg?token=' + to.query.token;
        return;
    } else if (to.path === '/login') {
        sessionStorage.removeItem('activeSideMenuId');
        sessionStorage.removeItem('BiTopMenuId');
        next();
    } else {
        !store.state.userInfo && await store.dispatch('selectUserInfo');
        !store.state.menuNewList.length && await store.dispatch('selectMenuList');
        let hasCustomReport = hasCustomReportMenu();
        console.log("是否有自定义报表菜单", hasCustomReport);
        if(hasCustomReport && to.path == '/customReport/customerReportSub') {
            store.dispatch('setActiveTopMenu', '2000036' || null);
            next();
        } else if(!hasCustomReport && to.path == '/customReport/customerReportSub') {
            // 根路径重定向
            if (to.path == '/customReport/customerReportSub') {
                const redirectPath = await processMenuNavigation();
                let { id, rootMenuId, path } = redirectPath?.data || {};
                console.log("有没有可用菜单", redirectPath)
                if(redirectPath) {
                    store.dispatch('setActiveTopMenu', rootMenuId || null);
                    store.dispatch('setActiveMenu', id);
                    next({
                        name: path
                    })
                } else {
                    next('403')
                }
                
            } else {
                next();
            }
        } else {
            next();
        }
    }
})

export default router;